// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__jYWPF","submit":"styles_submit__HCptf"};